(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var searchForm = document.querySelector(".custom-search .search-form");

  if (searchForm) {
    searchForm.addEventListener("submit", function(event) {
      event.preventDefault(); // Previene el comportamiento por defecto de envío del formulario

      var input = this.querySelector("input[name='q']");
      var searchTerm = input.value.trim(); // Obtiene el término de búsqueda introducido por el usuario

      // Construye la URL de búsqueda con el término introducido por el usuario
      var searchURL = `/search?type=product&q=${encodeURIComponent(searchTerm)}`;

      // Redirige al usuario a la página de resultados de búsqueda con los términos introducidos
      window.location.href = searchURL;
    });
  }
});
 

  } catch(e) { console.error(e); }
})();
})();
